import React, { useState, useEffect } from 'react';
import SecureShow from '../../component/SecureShow';
import SFCustomTable from '../../component/custom/SFCustomTable';
import { Button, SelectField } from 'react-md';
import AssignmentDetailModal from '../AssignmentMatrix/Modal/AssignmentDetailModal';
import ApiRequestService from '../../component/ApiRequestService';
import { NotificationManager } from 'react-notifications';
import { MdEdit } from "react-icons/md";
import { FiTrash2 } from "react-icons/fi";
import { IconButton, Tooltip } from '@mui/material';
import { IoMdLink } from "react-icons/io";
import ReactTooltip from 'react-tooltip';
import { GetViewRawDataURL, HandleResetStudentPreview } from '../../common/function';
import { IoDocumentTextOutline } from "react-icons/io5";
import DeleteDialog from '../DeleteDialog';


const Assessments = () => {
    const columns = [
        {
            name: 'ID',
            selector: (row) => {
                return row.quiz_id;
            },
            width: "200px",
            sortable: true,
        },
        {
            name: 'Assessment Name',
            selector: (row) => {
                return row.quiz_name;
            },
            sortable: true,
        },
        {
            name: 'Start Date',
            selector: (row) => {
                return row.start_date;
            },
            sortable: true,
        },
        {
            name: 'End Date',
            selector: (row) => {
                return row.end_date;
            },
            sortable: true,
        },
        {
            name: <div className='sf-data-table-header'>Actions</div>,
            sortable: false,
            cell: (rowData, rowIndex) => {
                return (
                    <div style={{
                        display: "flex",
                        justifyContent: 'flex-start',
                        gap: '2px',
                    }}>
                        <IconButton onClick={() => {
                            getQuizDetail(rowData.course_id, rowData.section_Id, rowData.quiz_id);
                        }}>
                            <MdEdit color='#3d5e9c' />
                        </IconButton>

                        <IconButton onClick={() => {
                            // let url = GetViewRawDataURL(rowData);
                            // window.location.href = url;

                            // For testing the create assignment from assessment response
                            getAssessmentRawData(rowData.quiz_id)
                        }}>
                            <IoDocumentTextOutline color='#3d5e9c' />
                        </IconButton>

                        <ReactTooltip id={'copy-link'} type='light' className='tool-tip'
                            effect='solid'
                        ><span>Copy link to clipboard</span></ReactTooltip>
                        <IconButton
                            data-tip
                            data-for={'copy-link'}
                            onClick={() => {
                                if (rowData && rowData.anonymous_link) {
                                    let link = rowData.anonymous_link;
                                    link = link.replace("asu.student.dev", "colorado.student.dev");
                                    navigator.clipboard.writeText(link);
                                    NotificationManager.success("Anonymous Link is copied to your clipboard.", "");
                                }
                            }}>
                            <IoMdLink color='#3d5e9c' />
                        </IconButton>

                        <IconButton onClick={() => {
                            setShowDeleteDialog(true);
                            setAssessment(rowData);
                        }}>
                            <FiTrash2 color='#bb0000' />
                        </IconButton>
                    </div>
                )
            },
            sortable: false,
        },
    ];

    const [assessments, setAssessments] = useState([]);
    const [showAssignmentDetailModal, setShowAssignmentDetailModal] = useState(false);
    const [assessment, setAssessment] = useState(null);
    const [loading, setLoading] = useState(false);

    // course data
    const [courseListArray, setCourseListArray] = useState([]);
    const [selectedCourseID, setSelectedCourseID] = useState(null);

    const [showDeleteDialog, setShowDeleteDialog] = useState(false);

    useEffect(() => {
        getAllCourses();
    }, []);

    useEffect(() => {
        if (selectedCourseID) {
            setLoading(true);
            getQuizesByCourseID(selectedCourseID);
        }
    }, [selectedCourseID])

    const getAssessmentRawData = (quizID) => {
        let payload = {
            quiz_id: quizID,
        }
        ApiRequestService({
            method: 'post',
            url: '/getAssessmentRawData',
            data: payload
        }).then(res => {
            
        })
    }

    const getQuizDetail = (courseID, sectionID, quizID) => {
        let payload = {
            course_id: courseID,
            section_id: sectionID,
            quiz_id: quizID,
        }
        ApiRequestService({
            method: 'post',
            url: '/getQuizById',
            data: payload
        }).then(res => {
            if (res.data.data !== null && res.data.data !== undefined && res.data.data.quiz_id) {
                setAssessment(res.data.data);
            }
            setShowAssignmentDetailModal(true);
        })
    }

    const makeCourselistArray = (courseObject, index) => {
        return {
            key: 'KEY_' + index,
            title: courseObject?.is_lti_enabled ? `${courseObject.course_name} (LTI Course)` : courseObject.course_name,
            isLTICourse: courseObject?.is_lti_enabled,
            value: courseObject.course_id
        };
    }

    const getAllCourses = () => {
        ApiRequestService({
            method: 'post',
            url: '/getAllCourses'
        }).then(res => {
            if (
                res.data.data.course_names !== undefined &&
                res.data.data.course_names !== null
            ) {
                let courseArray = res.data.data.course_names.map(makeCourselistArray);
                setCourseListArray(courseArray);
                if (courseArray && courseArray.length) {
                    setSelectedCourseID(courseArray[0].value);
                }

            } else {
                NotificationManager.error("Something went wrong", "Error");
            }
        })
    }

    const onCourseChange = (courseID) => {
        setSelectedCourseID(courseID);
    }

    const getQuizesByCourseID = (courseID) => {
        ApiRequestService({
            method: 'post',
            url: '/getAllQuiz',
            data: {
                course_id: courseID,
                is_assessment: true,
            }
        })
            .then(res => {
                if (res.data !== undefined && res.data !== null &&
                    res.data.data !== undefined && res.data.data !== null &&
                    res.data.data.quizes_list !== undefined &&
                    res.data.data.quizes_list !== null &&
                    res.data.data.quizes_list.length > 0
                ) {
                    let arr = res.data.data.quizes_list;
                    arr = arr.filter(quiz => quiz.deleted_by === "");
                    setAssessments(arr);
                } else {
                    setAssessments([]);
                }
            }).finally(() => {
                setLoading(false);
            })
    }

    const handleDeleteAssessment = () => {
        if (!assessment) return;

        setLoading(true);
        ApiRequestService({
            method: 'post',
            url: '/softDeleteQuiz',
            data: {
                quiz_id: assessment.quiz_id,
            }
        })
            .then(res => {
                if (res?.data?.message) {
                    NotificationManager.error(res?.data?.message, "Error");
                } else {
                    let index = assessments.findIndex(quiz => quiz.quiz_id === assessment.quiz_id);
                    if (index > -1) {
                        let newAssessments = [...assessments];
                        newAssessments.splice(index, 1);
                        setAssessments(newAssessments);
                    }
                }
            }).finally(() => {
                setAssessment(null);
                setShowDeleteDialog(false);
                setLoading(false);
            });
    }

    return (
        <SecureShow targetRole={1} >
            <div style={{
                padding: '0 0rem',
                marginTop: '-3.5rem',
            }}>
                <div style={{ padding: '0 1rem' }}>

                    <SelectField
                        id="selectCourses"
                        className="md-cell md-cell--4  md-cell--6-phone DashBoardSelectFieldBigClass selectFieldLeftAlign overflow-ellipsis-select"
                        placeholder="Select   Course"
                        itemLabel="title"
                        menuItems={courseListArray}
                        onChange={onCourseChange}
                        value={selectedCourseID}
                    />

                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <Button primary raised onClick={() => {
                            setAssessment(null);
                            setShowAssignmentDetailModal(true);
                        }}>
                            Add Assessment
                        </Button>
                    </div>
                </div>

                <SFCustomTable
                    columns={columns}
                    data={assessments}
                    showSearch={true}
                    loading={loading}
                    searchByFields={['quiz_name']}
                    searchPlaceholder="Search assessments"
                    topPagination={false}
                    bottomPagination={true}
                />
            </div>
            {showAssignmentDetailModal ?
                <AssignmentDetailModal
                    isAssessment={true}
                    isNewAssignment={false}
                    showModal={showAssignmentDetailModal}
                    assignment={assessment}
                    handleClose={() => {
                        setShowAssignmentDetailModal(false);
                    }}
                    onSaveAssignment={(data) => {
                        // setShowAssignmentDetailModal(false);
                    }}
                    course_id={selectedCourseID}
                    handleResetPreview={() => {
                        HandleResetStudentPreview(assessment, true, null);
                    }}
                    onAfterPreviewClick={() => { }}
                />
                : null}

            <DeleteDialog
                showDialog={showDeleteDialog}
                title={"Delete Assessment"}
                description={`Are you sure you want to delete "${assessment?.quiz_name}"?`}
                onCancel={() => setShowDeleteDialog(false)}
                onDelete={handleDeleteAssessment}
            />
        </SecureShow>
    );
}

export default Assessments;
